import { useStore } from "zustand";
import { useGlobalStore } from "../../../state/StoreContext";
import { useEffect } from "react";

export const usePaidPlanSubscription = (workspaceId = null) => {
    const globalStore = useGlobalStore();
    const subscription = useStore(
        globalStore,
        (state) => state.paidPlanSubscriptionById[workspaceId || state.currentWorkspaceId]?.data
    );
    const fetchPaidPlanSubscription = useStore(
        globalStore,
        (state) => state.fetchPaidPlanSubscription
    );
    const currentWorkspaceId = useStore(globalStore, (state) => state.currentWorkspaceId);

    useEffect(() => {
        const id = workspaceId || currentWorkspaceId;
        if (id) {
            fetchPaidPlanSubscription(id);
        }
    }, [workspaceId, currentWorkspaceId]);

    return {
        subscription,
        fetchPaidPlanSubscription: (options: Parameters<typeof fetchPaidPlanSubscription>[1]) => {
            fetchPaidPlanSubscription(workspaceId || currentWorkspaceId, options);
        }
    };
};
